import { Fragment, ReactNode, useEffect, useMemo, useState } from 'react';
import ReactHotkeys from 'react-hot-keys';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu, Modal, notification, Select } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { GO_TO_ADD_NEW_PATIENT, GO_TO_PATIENTS_DETAILS } from '../../routes/paths';
import {
    MISC_KEYS,
    getDefaultClinicId,
    getDocIds,
    getDoctorSelectorList,
    getItemFromMisc,
    getSelectedClinicId,
    getVisitByIds,
    isSingleDoctorAccess,
    upsertPatient,
} from '../../store/idbHandler';
import {
    Patient,
    getPtFullName,
    getPtFullNameWithSalutation,
    isLocalPt,
} from '../../store/types/patient';
import {
    addAlpha,
    getColorForString,
    getFirstAndLastCharName,
    getAllVisitsWithLinkedPatientIds,
    getPatientPicUrl,
    getPxPrintUrl,
    isOnboardedForLab,
    isOnboardedForPharma,
    onCreateVisit,
    toLocalPt,
} from '../../pages/utils';
import {
    AbhaIconLinkedMore,
    AbhaIconNotLinked,
    EkaIconGlobalSearch,
    EkaIconGlobalSearchRightPanel,
    GlobalSearchPtNotSelected,
} from '../common/Icons';
import { AntTooltip } from '../common/AntTooltip';
import { getAgeString } from '../../store/utils';
import fetchPatientDirByDocOid from '../../api/fetchPatientDirByDocOid';
import { AnimatePresence } from 'framer-motion';
import MedicalCertificateDialog from '../common/MedicalCertificateDialog';
import { track } from '../../tracking';
import { WithBEPatient, fetchPtDir, toLocalPatient } from '../../store/actions/app';
import archivePatientAPI from '../../api/archivePatient';
import MergeProfileDialog from '../common/MergeProfileDialog';
import { GLOBAL_SEARCH_PRINT, ICTAKEYS } from './types';
import { GLOBAL_SEARCH_APPT, patientFuseLimit } from './config';
import { getSearchResults, getSearchType, indexAllPatients } from '../../pages/allPatientsIndex';
import AttachmentModalGlobalSearch from './AttachmentModal';
import AddAddressGlobalSearch from './AddAddress';
import {
    ONGOING,
    PARKED,
    PARKED_ON_OTHER_DEVICE,
    RE_START,
    START_VISIT,
    getAppointmentAction,
    getAppointmentActionTextForAction,
    isCNRE,
    onAppointmentAction,
} from '../../pages/AppointmentUtils';
import { his } from '../../pages/history';
import { Appointment, AppointmentsResponse, fetchTodayQueue } from '../../api/fetchAppointmentsV2';
import { StartVisitBtn } from './StartVisitBtn';
import { GenieSettings, SREV2 } from '../../api/pushGenie';
import { printLabelForPatient } from '../../modules/barcode';
import { AddRecordsBtV2 } from '../../pages/MedicalRecordsRightPanel';
import { renderGlobalSearchApptComponent } from '../../bridge/methods';
import { DESTROY_CONTAINER } from '../../bridge/events/types';
import { dispatch as ekaDispatch } from '../../bridge/events/dispatch';
import DoctorReferralAllPatient from '../prescriptionPad/leftPanel/DoctorReferralAllPatient';
import { getMyIdWithBackwardCompatibility } from '../../api/mactiveid';
import { captureError } from '../../pages/captureError';
import { Visit } from '../../store/types/visit';
import { VisitWithLocalMassaging } from '../../pages/PastVisitsRightPanel';
import { getAclViewClassName } from '../../restrictions/utils';
import moment from 'moment';
import {
    getDefiniteMActiveId,
    getGlobalSearchParam,
    getMActiveId,
    setGlobalSearchParam,
} from '../../store/localstorage';
import { PtDir } from '../../api/fetchMyGenie';
import DoctorSelectorPopup from '../common/DoctorSelectorPopOver';
import { MyDoc } from '../../api/fetchMyProfile';
import { updateAddVisit } from '../../utils/commons';
import fetchProfilesByMobile from '../../api/fetchProfilesByMobile';
import { NewPatientLocationState } from '../../pages/NewPatient';
import CreateABHAModalSDK from '../abha/CreateABHAModalSdk';
import fetchPtGlobal, { PatientRes } from '../../api/fetchPtGlobal';
import debounce from 'lodash/debounce';
import { getBusinessUhidPrefix, getGlobalSearchFlag } from '../../store/selectors/session';
import archivePatientInParchi from '../../api/archivePatientInParchi';

const displayParamType = (val: 'phoneNumber' | 'uhid' | 'name'): string => {
    switch (val) {
        case 'phoneNumber':
            return 'Phone number';
        case 'uhid':
            return 'UHID';
        case 'name':
            return 'Name';
        default:
            return '';
    }
};

type AP = Appointment & { isLocalPresnt: boolean; localRxId?: string };

type GlobalSearchCTAArray = {
    key: ICTAKEYS;
    icon: JSX.Element;
    title: JSX.Element;
    dropDownOption?: boolean;
    closeGlobalSearch: boolean;
    clearGlobalSearchState: boolean;
    aclViewClassName?: string;
};

let globalSearchCTAArray: GlobalSearchCTAArray[] = [
    {
        key: 'PAST_VISITS',
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                <path d="M18.5312 6.0625L16.9375 4.46875C16.6562 4.1875 16.2812 4.03125 15.875 4H10.5C9.65625 4 9 4.6875 9 5.5V7H6.5C5.65625 7 5 7.6875 5 8.5V18.5C5 19.3438 5.65625 20 6.5 20H13.5C14.3125 20 15 19.3438 15 18.5V17H17.5C18.3125 17 19 16.3438 19 15.5V7.125C18.9688 6.71875 18.8125 6.34375 18.5312 6.0625ZM16 5.03125C16.0625 5.0625 16.1562 5.09375 16.2188 5.15625L17.8438 6.78125C17.9062 6.84375 17.9375 6.9375 17.9688 7H16V5.03125ZM14 18.5C14 18.7812 13.75 19 13.5 19H6.5C6.21875 19 6 18.7812 6 18.5V8.5C6 8.25 6.21875 8 6.5 8H9V15.5C9 16.3438 9.65625 17 10.5 17H14V18.5ZM18 15.5C18 15.7812 17.75 16 17.5 16H10.5C10.2188 16 10 15.7812 10 15.5V5.5C10 5.25 10.2188 5 10.5 5H15V7.25C15 7.6875 15.3125 8 15.75 8H18V15.5ZM14.8125 9.71875C14.8125 9.59375 14.7188 9.5 14.625 9.5H13.375C13.25 9.5 13.1562 9.59375 13.1562 9.71875V11.1875H11.6875C11.5625 11.1875 11.5 11.2812 11.5 11.375V12.625C11.5 12.75 11.5625 12.8438 11.6875 12.8438H13.1562V14.3125C13.1562 14.4375 13.25 14.5 13.375 14.5H14.625C14.7188 14.5 14.8125 14.4375 14.8125 14.3125V12.8438H16.2812C16.4062 12.8438 16.5 12.75 16.5 12.625V11.375C16.5 11.2812 16.4062 11.1875 16.2812 11.1875H14.8125V9.71875Z"></path>
            </svg>
        ),
        title: <p>Go to past visits</p>,
        closeGlobalSearch: true,
        clearGlobalSearchState: false,
    },
    {
        key: 'MCERT',
        icon: (
            <svg width="16" height="16" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M402 2.22c-8.5-3.953-18.53-2.547-25.66 3.578l-39.13 33.53l-32.28-32.28C296.5-1.42 283.1-2.342 273.6 4.814L224 42.01l-49.59-37.2C164.9-2.311 151.5-1.389 143 7.048L110.8 39.33L71.63 5.798c-7.109-6.125-17.17-7.531-25.66-3.578C37.45 6.126 32 14.64 32 24.02v463.1c0 9.374 5.453 17.89 13.97 21.8c8.484 3.937 18.55 2.531 25.66-3.578l39.13-33.53l32.28 32.28c8.438 8.468 21.81 9.359 31.38 2.234L224 469.1l49.59 37.2c9.562 7.156 22.92 6.265 31.38-2.234l32.28-32.28l39.13 33.53c4.438 3.812 10 5.781 15.62 5.781c3.406 0 6.828-.7187 10.03-2.203C410.5 505.9 416 497.4 416 487.1V24.02C416 14.64 410.5 6.126 402 2.22zM368 435.8l-16.38-14.03c-9.531-8.171-23.7-7.625-32.59 1.25l-33.28 33.28L238.4 420.8C234.1 417.6 229.1 415.1 224 415.1S213.9 417.6 209.6 420.8l-47.34 35.51l-33.28-33.28c-8.875-8.874-23.05-9.421-32.59-1.25L80 435.8V76.2L96.38 90.23c9.547 8.187 23.72 7.656 32.59-1.25l33.28-33.28l47.34 35.51c8.531 6.406 20.28 6.406 28.81 0l47.34-35.51l33.28 33.28c8.891 8.906 23.06 9.437 32.59 1.25L368 76.2V435.8zM312 160h-176c-8.844 0-16 7.156-16 15.1s7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1S320.8 160 312 160zM312 319.1h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 327.2 320.8 319.1 312 319.1zM312 240h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 247.2 320.8 240 312 240z"></path>
            </svg>
        ),
        title: <p>Create medical documents</p>,
        closeGlobalSearch: true,
        clearGlobalSearchState: true,
        aclViewClassName: getAclViewClassName(SREV2.CREATE_MEDICAL_DOCUMENTS),
    },
    {
        key: 'ARCHIVE',
        icon: (
            <svg
                className="fill-red-primary"
                width="16"
                height="16"
                viewBox="0 0 12 14"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M11.0781 2.15625C11.4082 2.15625 11.6875 2.43555 11.6875 2.76562C11.6875 3.12109 11.4082 3.375 11.0781 3.375H10.7734L10.1641 11.627C10.0879 12.4902 9.40234 13.125 8.53906 13.125H3.43555C2.57227 13.125 1.88672 12.4902 1.81055 11.627L1.20117 3.375H0.921875C0.566406 3.375 0.3125 3.12109 0.3125 2.76562C0.3125 2.43555 0.566406 2.15625 0.921875 2.15625H2.67383L3.61328 0.759766C3.86719 0.378906 4.32422 0.125 4.80664 0.125H7.16797C7.65039 0.125 8.10742 0.378906 8.36133 0.759766L9.30078 2.15625H11.0781ZM4.80664 1.34375C4.73047 1.34375 4.6543 1.39453 4.62891 1.44531L4.14648 2.15625H7.82812L7.3457 1.44531C7.32031 1.39453 7.24414 1.34375 7.16797 1.34375H4.80664ZM9.55469 3.375H2.41992L3.0293 11.5508C3.05469 11.7539 3.23242 11.9062 3.43555 11.9062H8.53906C8.74219 11.9062 8.91992 11.7539 8.94531 11.5508L9.55469 3.375Z" />
            </svg>
        ),
        dropDownOption: true,
        title: <p className="text-red-primary">Archive patient</p>,
        closeGlobalSearch: false,
        clearGlobalSearchState: true,
        aclViewClassName: getAclViewClassName(SREV2.PATIENT_DATABASE),
    },
    {
        key: 'SEND_ATTACHMENT',
        icon: (
            <svg width="16" height="16" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.83398 1.97852C9.17383 1.31836 8.08203 1.31836 7.42188 1.97852L2.54688 6.85352C1.45508 7.9707 1.45508 9.77344 2.54688 10.8652C3.66406 11.9824 5.4668 11.9824 6.58398 10.8652L10.4434 7.00586C10.6719 6.77734 11.0527 6.77734 11.2812 7.00586C11.5352 7.25977 11.5352 7.64062 11.2812 7.86914L7.42188 11.7285C5.84766 13.3281 3.2832 13.3281 1.70898 11.7285C0.109375 10.1543 0.109375 7.58984 1.70898 5.99023L6.58398 1.14062C7.70117 -0.00195312 9.55469 -0.00195312 10.6719 1.14062C11.8145 2.25781 11.8145 4.11133 10.6719 5.22852L6.02539 9.90039C5.21289 10.7129 3.89258 10.6367 3.18164 9.74805C2.57227 8.98633 2.64844 7.89453 3.33398 7.20898L7.19336 3.34961C7.42188 3.12109 7.80273 3.12109 8.03125 3.34961C8.28516 3.60352 8.28516 3.98438 8.03125 4.21289L4.19727 8.07227C3.94336 8.32617 3.91797 8.70703 4.14648 8.98633C4.40039 9.31641 4.85742 9.3418 5.16211 9.03711L9.83398 4.36523C10.4941 3.73047 10.4941 2.63867 9.83398 1.97852Z" />
            </svg>
        ),
        title: <p>Send files</p>,
        closeGlobalSearch: false,
        clearGlobalSearchState: true,
        aclViewClassName: getAclViewClassName(SREV2.SEND_ATTACHMENT),
    },
    {
        key: 'REFER',
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13" width="16" height="16">
                <path d="M9.1875 8.2373C8.85938 8.2373 8.625 8.49512 8.625 8.7998V11.4248C8.625 11.542 8.53125 11.6123 8.4375 11.6123H1.3125C1.19531 11.6123 1.125 11.542 1.125 11.4248V4.2998C1.125 4.20605 1.19531 4.1123 1.3125 4.1123H3.9375C4.24219 4.1123 4.5 3.87793 4.5 3.5498C4.5 3.24512 4.24219 2.9873 3.9375 2.9873H1.3125C0.585938 2.9873 0 3.59668 0 4.2998V11.4248C0 12.1514 0.585938 12.7373 1.3125 12.7373H8.4375C9.14062 12.7373 9.75 12.1514 9.75 11.4248V8.7998C9.75 8.49512 9.49219 8.2373 9.1875 8.2373ZM11.4375 0.737305H7.5C7.17188 0.737305 6.9375 0.995117 6.9375 1.2998C6.9375 1.62793 7.17188 1.8623 7.5 1.8623H10.0781L4.28906 7.65137C4.05469 7.88574 4.05469 8.2373 4.28906 8.44824C4.38281 8.56543 4.52344 8.6123 4.6875 8.6123C4.82812 8.6123 4.96875 8.56543 5.0625 8.44824L10.875 2.65918V5.2373C10.875 5.56543 11.1094 5.7998 11.4375 5.7998C11.7422 5.7998 12 5.56543 12 5.2373V1.2998C12 0.995117 11.7422 0.737305 11.4375 0.737305Z"></path>
            </svg>
        ),
        title: <p>Refer to a doctor</p>,
        closeGlobalSearch: true,
        clearGlobalSearchState: true,
        aclViewClassName: getAclViewClassName(SREV2.REFER_PATIENT_TO_DOCTOR),
    },
    {
        key: 'MERGE_PROFILE',
        icon: (
            <svg width="16" height="16" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 1.35938C0.5 1.0293 0.753906 0.75 1.10938 0.75H4.15625C4.58789 0.75 5.01953 0.978516 5.27344 1.33398L8.04102 4.93945C8.06641 4.99023 8.14258 5.01562 8.19336 5.01562H11.418L10.4277 4.02539C10.1738 3.79688 10.1738 3.41602 10.4277 3.16211C10.6562 2.93359 11.0371 2.93359 11.2656 3.16211L13.2969 5.19336C13.5508 5.44727 13.5508 5.82812 13.2969 6.05664L11.2656 8.08789C11.0371 8.3418 10.6562 8.3418 10.4277 8.08789C10.1738 7.85938 10.1738 7.47852 10.4277 7.22461L11.418 6.23438H8.19336C8.14258 6.23438 8.06641 6.28516 8.04102 6.33594L5.27344 9.94141C5.01953 10.2969 4.58789 10.5 4.15625 10.5H1.10938C0.753906 10.5 0.5 10.2461 0.5 9.89062C0.5 9.56055 0.753906 9.28125 1.10938 9.28125H4.15625C4.20703 9.28125 4.2832 9.25586 4.30859 9.20508L7.02539 5.625L4.30859 2.07031C4.2832 2.01953 4.20703 1.96875 4.15625 1.96875H1.10938C0.753906 1.96875 0.5 1.71484 0.5 1.35938Z" />
            </svg>
        ),
        dropDownOption: true,
        title: <p>Merge profiles</p>,
        closeGlobalSearch: true,
        clearGlobalSearchState: true,
        aclViewClassName: getAclViewClassName(SREV2.MERGE_PATIENTS),
    },
];

async function toggleAddAddress() {
    if (isSingleDoctorAccess() && (isOnboardedForPharma() || isOnboardedForLab())) {
        if (!globalSearchCTAArray.find((cta) => cta.key === 'ADD_ADDRESS')) {
            globalSearchCTAArray.push({
                key: 'ADD_ADDRESS',
                icon: (
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 10 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7.03125 5C7.03125 6.14258 6.11719 7.03125 5 7.03125C3.85742 7.03125 2.96875 6.14258 2.96875 5C2.96875 3.88281 3.85742 2.96875 5 2.96875C6.11719 2.96875 7.03125 3.88281 7.03125 5ZM5 4.1875C4.54297 4.1875 4.1875 4.56836 4.1875 5C4.1875 5.45703 4.54297 5.8125 5 5.8125C5.43164 5.8125 5.8125 5.45703 5.8125 5C5.8125 4.56836 5.43164 4.1875 5 4.1875ZM9.875 5C9.875 7.23438 6.9043 11.1699 5.58398 12.8203C5.2793 13.2012 4.69531 13.2012 4.39062 12.8203C3.07031 11.1699 0.125 7.23438 0.125 5C0.125 2.30859 2.2832 0.125 5 0.125C7.69141 0.125 9.875 2.30859 9.875 5ZM5 1.34375C2.96875 1.34375 1.34375 2.99414 1.34375 5C1.34375 5.33008 1.44531 5.8125 1.72461 6.47266C1.97852 7.08203 2.35938 7.79297 2.79102 8.50391C3.52734 9.67188 4.36523 10.7891 5 11.6016C5.60938 10.7891 6.44727 9.67188 7.18359 8.50391C7.61523 7.79297 7.99609 7.08203 8.25 6.47266C8.5293 5.8125 8.65625 5.33008 8.65625 5C8.65625 2.99414 7.00586 1.34375 5 1.34375Z" />
                    </svg>
                ),
                dropDownOption: true,
                title: <p>Add address</p>,
                closeGlobalSearch: true,
                clearGlobalSearchState: true,
                aclViewClassName: getAclViewClassName(SREV2.ADD_PATIENT_ADDRESS),
            });
        }
    } else {
        globalSearchCTAArray = globalSearchCTAArray.filter((cta) => cta.key !== 'ADD_ADDRESS');
    }
}

async function togglePrintLabel(isBarCodeEnabled: boolean) {
    if (isBarCodeEnabled) {
        if (!globalSearchCTAArray.find((cta) => cta.key === 'PRINT_LABEL')) {
            globalSearchCTAArray = [
                ...globalSearchCTAArray.map((cta) => {
                    if (cta.key === 'SEND_ATTACHMENT') {
                        return {
                            ...cta,
                            dropDownOption: true,
                        };
                    } else {
                        return cta;
                    }
                }),
                {
                    key: 'PRINT_LABEL',
                    icon: (
                        <svg
                            width={16}
                            height={16}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M112 160V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208H384v96H128V368zm-16-48c-17.7 0-32 14.3-32 32H48V256c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96H432c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64V368c0 17.7 14.3 32 32 32H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400z" />
                        </svg>
                    ),
                    dropDownOption: false,
                    title: <p>Print Label</p>,
                    closeGlobalSearch: true,
                    clearGlobalSearchState: true,
                },
            ];
        }
    } else {
        globalSearchCTAArray = globalSearchCTAArray
            .filter((cta) => cta.key !== 'PRINT_LABEL')
            .map((cta) => {
                if (cta.key === 'SEND_ATTACHMENT') {
                    return {
                        ...cta,
                        dropDownOption: false,
                    };
                } else {
                    return cta;
                }
            });
    }
}

export enum SearchType {
    UHID = 'uhid',
    PHONE = 'phoneNumber',
    ALL = 'all',
    NAME = 'name',
}

const searchTypeOptions = [
    { value: SearchType.ALL, label: 'All' },
    { value: SearchType.UHID, label: 'UHID' },
    { value: SearchType.NAME, label: 'Name' },
    { value: SearchType.PHONE, label: 'Phone number' },
];

const GlobalSearchModal: React.FC<{
    isGlobalSearchVisible: boolean;
    close: () => void;
    onSelectPatient?: (patient: Patient) => void;
    onAddPatient?: (state: NewPatientLocationState) => void;
    onAddPatientViaAbha?: (
        state: NewPatientLocationState,
        flow: 'create_abha_with_mobile' | 'login_with_abha',
    ) => void;
}> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const params: { cId: string } = useParams();
    const uhidPrefix = useSelector(getBusinessUhidPrefix);

    const { isGlobalSearchVisible, close } = props;
    const [searchInput, setSearchInput] = useState<string>();
    const [selectedPatient, setSelectedPatient] = useState<Patient>();
    const [searchInputType, setSearchInputType] = useState<'name' | 'phoneNumber'>();
    const [patientPicUrl, setPatientPicUrl] = useState<string>();
    const [searchResult, setSearchResult] = useState<Patient[]>([]);
    const [apiSearchResult, setApiSearchResult] = useState<Patient[]>([]);
    const [isPrintRxLoading, setIsPrintRxLoading] = useState(false);
    const [todayAppointments, setTodayAppointments] = useState<AP[]>([]);
    const [isAbdmEnabled, setIsAbdmEnabled] = useState<boolean>(false);

    const [referPt, setReferPt] = useState<boolean>(false);
    const [isMedicalCertificate, setIsMedicalCertificate] = useState<string | undefined>();
    const [isSendAttachment, setIsSendAttachmente] = useState<boolean>(false);
    const [isMergePt, setIsMergePt] = useState(false);
    const [showAddAddress, setShowAddAddress] = useState(false);
    const [allVisits, setAllVisits] = useState<VisitWithLocalMassaging[]>([]);
    const [searchType, setSearchType] = useState<SearchType>(
        getGlobalSearchParam() ?? SearchType.ALL,
    );
    const [gSearchLoading, setGSearchLoading] = useState(false);
    const [currParamType, setCurrParamType] = useState<
        'phoneNumber' | 'name' | 'uhid' | undefined
    >();
    const enableBEGlobalSearch = useSelector(getGlobalSearchFlag);

    const useGlobalSearch = enableBEGlobalSearch;

    useEffect(() => {
        getItemFromMisc<GenieSettings>(getDefiniteMActiveId(), MISC_KEYS.settings).then((res) => {
            if (res) {
                setIsAbdmEnabled(res.abdm);
            }
        });
    }, []);

    const debouncedFetchPtGlobal = useMemo(
        () =>
            debounce(
                (
                    input: string,
                    param: string,
                    callback: (res: PatientRes[]) => void,
                    errcb: (err: any) => void,
                ) => {
                    if ((input || '').length < 3) {
                        setGSearchLoading(false);
                        return;
                    }

                    fetchPtGlobal(input, param)
                        .then(callback)
                        .catch(errcb)
                        .finally(() => {
                            setGSearchLoading(false);
                        });
                },
                400,
            ),
        [],
    );

    const onMount = () => {
        if (isGlobalSearchVisible) {
            referPt && setReferPt(false);
            isMedicalCertificate && setIsMedicalCertificate(undefined);
            isSendAttachment && setIsSendAttachmente(false);
            isMergePt && setIsMergePt(false);
            showAddAddress && setShowAddAddress(false);
        }

        toggleAddAddress().catch((e) => console.error(e));

        getItemFromMisc<GenieSettings>(getMyIdWithBackwardCompatibility() || '', MISC_KEYS.settings)
            .then((res) => {
                togglePrintLabel(res.barcodeEnabled).catch((e) => {
                    throw e;
                });
            })
            .catch((e) => console.error(e));

        fetchTodayQueue(getSelectedClinicId() ?? '')
            .then(async (response: AppointmentsResponse) => {
                if (!response.response?.apt) {
                    return;
                }

                const list = response.response.apt.filter((t) => !isCNRE(t.status));
                const visitIds = list.map((a) => a.aid);
                const localVisits = (await getVisitByIds(visitIds)) || [];
                const localContextList = list.map((a, index) => ({
                    ...a,
                    isLocalPresnt: localVisits[index] !== undefined,
                }));

                setTodayAppointments(localContextList);
            })
            .catch((e) => console.error(e));
    };

    useEffect(() => {
        if (isGlobalSearchVisible === false) {
            setSearchInput(undefined);
        }

        onMount();
    }, [isGlobalSearchVisible]);

    const archivePatient = (options?: { clearGlobalSearchState?: boolean }) => {
        if (selectedPatient) {
            Modal.confirm({
                title: `This patient: ${selectedPatient.personal.name.f} will be removed from your directory & you won't be able to see their data.`,
                okText: 'Confirm',
                okButtonProps: { className: 'primary-btn font-lato' },
                cancelButtonProps: { className: 'neutral-btn font-lato' },
                onOk: () => {
                    WithBEPatient<Patient>(
                        selectedPatient,
                        async (bePt: Patient) => bePt,
                    )(dispatch)
                        .then(async (bePt) => {
                            if (bePt) {
                                await Promise.all([
                                    archivePatientAPI(bePt.id || bePt.localId),
                                    archivePatientInParchi(bePt.id || bePt.localId),
                                ]);
                                await upsertPatient({ ...bePt, archived: true });
                                fetchPtDir();
                            } else {
                                track('ERROR', {
                                    on: 'archivPatient',
                                    what: 'could not find patient by id',
                                });
                                alert('Failed to archive patient');
                            }
                        })
                        .catch((e) => {
                            track('ERROR', { on: 'archivPatient', what: 'idk', error: e.message });
                            alert('Failed to archive patient');
                        })
                        .finally(() => {
                            closeModal({
                                clearGlobalSearchState:
                                    (options && options.clearGlobalSearchState) ?? false,
                            });
                        });
                },
                cancelText: 'Cancel',
            });
        }
    };

    const onPrint = async (p: Patient) => {
        try {
            setIsPrintRxLoading(true);
            const settings = await getItemFromMisc<PtDir>(getMActiveId() || '', 'ptDir');

            const ptDir = await fetchPatientDirByDocOid(
                !settings.userLevel ? ['all'] : getDocIds(),
                p.id,
            );

            if (!ptDir.data) {
                throw new Error("Couldn't load patient directory");
            }

            const patient = ptDir.data.find((pt) => pt.id === p.id);

            if (!patient) {
                throw new Error("Couldn't find patient");
            }

            if (!patient.visits) {
                throw new Error("Couldn't find visits for the patient");
            }

            // This needs to be refacttored, print func should take rx id in itself
            const latestVisit = patient?.visits
                .filter((t) => t.status.toLowerCase() === 'cm')
                .sort((a, b) => (moment(a.visit_date).isBefore(b.visit_date) ? 1 : 0))[0];

            const url = getPxPrintUrl(latestVisit.pxid);
            const iframe = document.createElement('iframe');

            iframe.onload = () => {
                setIsPrintRxLoading(false);
                iframe.contentWindow?.print();
            };

            iframe.src = url;
            const t = document.getElementById(GLOBAL_SEARCH_PRINT);
            if (t) {
                t.innerHTML = '';
                t.appendChild(iframe);
            }
        } catch (e) {
            setIsPrintRxLoading(false);
            notification.error({ message: "Couldn't print prescription", duration: 5 });
        }
    };

    const closeModal = (
        options: { clearGlobalSearchState?: boolean } = { clearGlobalSearchState: false },
    ) => {
        // if (options.clearGlobalSearchState) {
        //    setSearchInput(undefined);
        // }
        setSearchInput(undefined);
        setSearchResult([]);
        close();
    };

    const onSearchChange = (input: string): void => {
        setSearchInput(input);
        setSelectedPatient(undefined);

        if (useGlobalSearch) {
            let type = searchType;
            if (searchType === SearchType.ALL) {
                type = getSearchType(input, uhidPrefix) as SearchType;
                setCurrParamType(type as 'phoneNumber' | 'name' | 'uhid');
            }
            let param = 'name';
            if (type === 'name') {
                param = 'name';
            } else if (type === 'phoneNumber') {
                param = 'mobile';
            } else if (type === 'uhid') {
                param = 'username';
            }
            if (input.length >= 3) setGSearchLoading(true);
            debouncedFetchPtGlobal(
                input,
                param,
                (res) => {
                    if (input.length < 3) {
                        setGSearchLoading(false);
                        return;
                    }
                    if (Array.isArray(res)) {
                        const ptProfile: Patient[] = toLocalPt(res);
                        setSearchResult(ptProfile);
                    } else setSearchResult([]);
                },
                (err) => {
                    console.log(err);
                    setSearchResult([]);
                },
            );
            setSearchInputType(type === 'uhid' ? 'phoneNumber' : (type as 'name' | 'phoneNumber'));
        } else {
            indexAllPatients().then(({ patientsFuse }) => {
                const results = getSearchResults(input, patientsFuse, patientFuseLimit);
                const ptSearchResult = results.filteredPatients;
                setSearchInputType(
                    results.inputType === 'uhid'
                        ? 'phoneNumber'
                        : (results.inputType as 'name' | 'phoneNumber'),
                );
                setSearchResult(ptSearchResult);
            });
            const phone = input.replace(/\D/g, '').trim();

            if (phone && phone.length === 10) {
                fetchProfilesByMobile(`+91${phone}`, getDefaultClinicId(), isAbdmEnabled).then(
                    (res) => {
                        if (res.success) {
                            const allPtSet = new Set(searchResult?.map((t) => t.localId));

                            setApiSearchResult(
                                res.profiles
                                    .map((p) => {
                                        if (!allPtSet.has(p.id)) {
                                            return p;
                                        }
                                        return p;
                                    })
                                    .filter((p) => p),
                            );
                        }
                    },
                );
            }
        }
    };

    const onAddPatient = () => {
        closeModal();

        if (props.onAddPatient) {
            props.onAddPatient({
                [searchInputType as 'name' | 'phoneNumber']: searchInput,
                isFieldDisabled: false,
            });
            return;
        }

        history.push({
            pathname: GO_TO_ADD_NEW_PATIENT(params.cId ?? getSelectedClinicId()),
            state: {
                [searchInputType as 'name' | 'phoneNumber']: searchInput,
                isFieldDisabled: false,
            },
        });
    };

    const onSelect = async (p: Patient) => {
        if (p.personal.fromNdhmDiscovery) {
            history.push({
                pathname: GO_TO_ADD_NEW_PATIENT(params.cId ?? getSelectedClinicId()),
                state: {
                    phoneNumber: p.personal.phone?.n,
                    name: p.personal.name.f,
                    gender: p.personal.gender,
                },
            });
            closeModal();
            return;
        }
        if (props.onSelectPatient) {
            props.onSelectPatient(p);
            closeModal();
            return;
        }

        if (p?.id) {
            fetchVisits(p.id);
            await setUpVisit(p.id);
        }
        track('GLOBAL_SEARCH_RIGHT_PANEL', { pid: p.id ?? '' });
        setPatientPicUrl(getPatientPicUrl(p.id));
        setSelectedPatient(p);
    };
    const setUpVisit = async (plId: string) => {
        const allVisits = await getAllVisitsWithLinkedPatientIds(plId);

        if (!allVisits || allVisits.length === 0) {
            setAllVisits([]);
            return;
        }

        const visitsToSet: (Visit & { localInCompletePxId?: string[] })[] = [];

        for (let index = 0; index < allVisits.length; index++) {
            const v: Visit & { localInCompletePxId?: string[] } = allVisits[index];
            // Skip visits with status 'BK'
            if (v.status === 'BK') {
                continue;
            }
            visitsToSet.push(v);
        }
        // Sort visits by createdAt date in descending order
        const sortedVisits = visitsToSet.sort(
            (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        );

        setAllVisits(sortedVisits);
    };

    const fetchVisits = async (plId: string) => {
        if (isLocalPt(plId)) {
            // local pt, can't fetch past visits from BE for a local patient
            track('ERROR', { on: 'fetching past visits for a local patient id' });

            return;
        }

        try {
            const res = await fetchPatientDirByDocOid(getDocIds(), plId);
            const pts = res.data?.filter((item) => item.id === plId);

            if (res.status !== 'success' || !res.data || pts?.length !== 1) {
                alert('Failed to fetch latest details of the patient  [4]');
                track('ERROR', { on: 'fetching latest details of the patient' });
                return;
            }

            const upsertsPromises: (Promise<void> | void)[] = res.data.reduce(
                (upserts, pt) =>
                    pt.visits
                        ? upserts.concat(
                              pt.visits.map((v) => {
                                  if (v.status === 'BK') {
                                      return;
                                  }
                                  return updateAddVisit(pt, v);
                              }),
                          )
                        : upserts,
                [] as (Promise<void> | void)[],
            );

            if (!upsertsPromises.length) {
                return;
            }

            await Promise.all(upsertsPromises);

            await setUpVisit(plId);
        } catch (e) {
            console.error(e);
            captureError(e as Error);
            alert('Failed to fetch latest details of the patient [5]');
            track('ERROR', {
                on: 'fetching latest details of the patient due to no internet connection',
                error: (e as Error).message,
            });
        }
    };

    const goToPatientDetails = () => {
        closeModal();
        history.push(GO_TO_PATIENTS_DETAILS(selectedPatient?.id ?? '', 'visit'));
    };

    const printLabel = () => {
        if (selectedPatient) {
            track('Print_label', { from: 'Global_Search' });
            printLabelForPatient(selectedPatient);
        }
    };

    const ptDetailsCtaActions: Record<ICTAKEYS, any> = {
        PAST_VISITS: (options?: { clearGlobalSearchState?: boolean }) =>
            history.push(GO_TO_PATIENTS_DETAILS(selectedPatient?.id ?? '', 'visit')),
        MCERT: (options?: { clearGlobalSearchState?: boolean; doc?: MyDoc }) =>
            setIsMedicalCertificate((prev) => options?.doc?.id || getDoctorSelectorList()[0].id),
        SEND_ATTACHMENT: (options?: { clearGlobalSearchState?: boolean }) => {
            setIsSendAttachmente((prev) => !prev);
            closeModal({ clearGlobalSearchState: options?.clearGlobalSearchState });
        },
        REFER: (options?: { clearGlobalSearchState?: boolean }) => setReferPt((prev) => !prev),
        ADD_ADDRESS: (options?: { clearGlobalSearchState?: boolean }) => setShowAddAddress(true),
        ARCHIVE: (options?: { clearGlobalSearchState?: boolean }) => archivePatient(options),
        MERGE_PROFILE: (options?: { clearGlobalSearchState?: boolean }) => setIsMergePt(true),
        PRINT_LABEL: (options?: { clearGlobalSearchState?: boolean }) => printLabel(),
    };

    const ptDetailsCtaActionsClosure = (key: ICTAKEYS) => {
        return ptDetailsCtaActions[key];
    };

    const globalSearchCTAObjWithActions = globalSearchCTAArray.map((obj) => {
        return {
            ...obj,
            action: (options?: {
                closeGlobalSearchDialog?: boolean;
                clearGlobalSearchState?: boolean;
            }) => {
                options &&
                    options.closeGlobalSearchDialog &&
                    closeModal({ clearGlobalSearchState: options.clearGlobalSearchState });
                track('GLOBAL_SEARCH_CTA', { what: obj.key });
                ptDetailsCtaActionsClosure(obj.key as ICTAKEYS)(options);
            },
        };
    });

    const globalSearchCTAObjWithActionsMain = globalSearchCTAObjWithActions.filter(
        (option) => !option.dropDownOption,
    );

    const globalSearchCTAObjWithActionsDropdown = globalSearchCTAObjWithActions
        .filter((option) => option.dropDownOption === true)
        .reverse(); // reversing the array to make sure archive is the last element always

    return (
        <Fragment>
            <ReactHotkeys keyName="esc" onKeyDown={() => closeModal()}>
                <Modal
                    closeIcon={() => null}
                    closable={false}
                    footer={null}
                    visible={isGlobalSearchVisible}
                    onCancel={() => closeModal()}
                    bodyStyle={{
                        padding: 0,
                        borderRadius: 8,
                        overflowY: 'auto',
                        maxHeight: 'calc(100vh - 200px)',
                    }}
                    destroyOnClose
                    className="global-search-modal"
                    style={{ zIndex: 9999 }}
                >
                    <div
                        style={{ width: 0, height: 0, visibility: 'hidden' }}
                        id={GLOBAL_SEARCH_PRINT}
                    ></div>
                    <div className="global-search flex flex-col max-h-inherit">
                        <div className="flex py-12 px-16 gap-16 items-center">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19.75 18.7188C20.0625 19.0312 20.0625 19.5 19.75 19.7812C19.625 19.9375 19.4375 20 19.25 20C19.0312 20 18.8438 19.9375 18.6875 19.7812L14.5 15.5938C13.375 16.5 11.9688 17 10.4688 17C6.90625 17 4 14.0938 4 10.5C4 6.9375 6.875 4 10.4688 4C14.0312 4 16.9688 6.9375 16.9688 10.5C16.9688 12.0312 16.4688 13.4375 15.5625 14.5312L19.75 18.7188ZM5.5 10.5C5.5 13.2812 7.71875 15.5 10.5 15.5C13.25 15.5 15.5 13.2812 15.5 10.5C15.5 7.75 13.25 5.5 10.5 5.5C7.71875 5.5 5.5 7.75 5.5 10.5Z"
                                    fill="#1A1A1A"
                                />
                            </svg>
                            <input
                                id="ALL_PATIENTS_INPUT_FIELD_GLOBAL_SEARCH"
                                type="search"
                                className="bg-transparent w-full focus:outline-none placeholder-darwin-neutral_new-400 text-14"
                                name="ether-search-component"
                                autoComplete="off"
                                placeholder="Search by UHID, Phone, Name"
                                autoFocus={true}
                                value={searchInput}
                                onChange={(e) => onSearchChange(e.target.value)}
                            />
                            {useGlobalSearch && (
                                <Select
                                    size="small"
                                    value={searchType}
                                    onChange={(val) => {
                                        setSearchType(val);
                                        setGlobalSearchParam(val);
                                    }}
                                    className="w-200"
                                    options={searchTypeOptions}
                                />
                            )}
                        </div>
                        {searchInput && (
                            <div className="border-t flex border-darwin-neutral_new-200 max-h-524 h-524 overflow-hidden">
                                <GlobalSearchLeftPanel
                                    onAddPatient={onAddPatient}
                                    onAddPatientViaAbha={
                                        props.onAddPatientViaAbha
                                            ? (flow) => {
                                                  closeModal();
                                                  props.onAddPatientViaAbha?.(
                                                      {
                                                          [searchInputType as
                                                              | 'name'
                                                              | 'phoneNumber']: searchInput,
                                                          isFieldDisabled: false,
                                                      },
                                                      flow,
                                                  );
                                              }
                                            : undefined
                                    }
                                    searchInput={searchInput}
                                    searchResult={[...searchResult, ...apiSearchResult]}
                                    selectedPatient={selectedPatient}
                                    setSelectedPatient={(p: Patient) => onSelect(p)}
                                    gSearchLoading={gSearchLoading}
                                    searchType={searchType}
                                    useGlobalSearch={useGlobalSearch}
                                    currParamType={currParamType}
                                />
                                <GlobalSearchRightPanel
                                    selectedPatient={selectedPatient}
                                    patientPicUrl={patientPicUrl}
                                    goToPatientDetails={goToPatientDetails}
                                    allVisits={allVisits}
                                    onPrint={onPrint}
                                    isPrintRxLoading={isPrintRxLoading}
                                    globalSearchCTAObjWithActionsMain={
                                        globalSearchCTAObjWithActionsMain
                                    }
                                    globalSearchCTAObjWithActionsDropdown={
                                        globalSearchCTAObjWithActionsDropdown
                                    }
                                    closeGlobalSearch={closeModal}
                                    todayAppointments={todayAppointments}
                                    key={selectedPatient?.id}
                                />
                            </div>
                        )}
                    </div>
                </Modal>
                <AnimatePresence>
                    {referPt && selectedPatient && (
                        <DoctorReferralAllPatient
                            ptId={selectedPatient?.id ?? ''}
                            close={() => setReferPt(false)}
                            ptName={getPtFullName(selectedPatient)}
                            docid={getDoctorSelectorList()?.[0].id}
                        />
                    )}
                    {isMedicalCertificate && selectedPatient && (
                        <MedicalCertificateDialog
                            patient={selectedPatient}
                            closeMe={() => setIsMedicalCertificate(undefined)}
                            zIndex={9999}
                            docid={isMedicalCertificate}
                        />
                    )}
                    {selectedPatient && (
                        <AttachmentModalGlobalSearch
                            patient={selectedPatient}
                            isSendAttachment={isSendAttachment}
                            onVisibleChange={(visible) => {
                                setIsSendAttachmente(visible);
                            }}
                        />
                    )}
                    {isMergePt && (
                        <MergeProfileDialog
                            onClose={() => {
                                setIsMergePt(false);
                                fetchPtDir();
                            }}
                            ptOid={
                                selectedPatient && selectedPatient['id']
                                    ? selectedPatient['id']
                                    : undefined
                            }
                        />
                    )}
                    {showAddAddress && (
                        <AddAddressGlobalSearch
                            patient={selectedPatient}
                            setShowAddAddress={(val: boolean) => setShowAddAddress(val)}
                        />
                    )}
                </AnimatePresence>
            </ReactHotkeys>
        </Fragment>
    );
};

const GlobalSearchLeftPanel: React.FC<{
    searchInput: string | undefined;
    searchResult: any[];
    selectedPatient: Patient | undefined;
    setSelectedPatient: (p: Patient) => void;
    onAddPatient: () => void;
    onAddPatientViaAbha?: (flow: 'create_abha_with_mobile' | 'login_with_abha') => void;
    gSearchLoading?: boolean;
    searchType?: SearchType;
    useGlobalSearch?: boolean;
    currParamType?: 'phoneNumber' | 'uhid' | 'name';
}> = (props) => {
    const {
        searchResult,
        setSelectedPatient,
        onAddPatient,
        onAddPatientViaAbha,
        gSearchLoading,
        searchType,
        searchInput,
        useGlobalSearch,
        currParamType,
    } = props;
    const prefix = useSelector(getBusinessUhidPrefix);
    return (
        <div className="w-50p pt-16 flex flex-col gap-4 border-r flex border-darwin-neutral_new-200">
            <p className="text-darwin-neutral_new-600 px-16 pb-4 text-14">
                {gSearchLoading && useGlobalSearch
                    ? `Searching${
                          searchType === SearchType.ALL && currParamType
                              ? ` by ${displayParamType(currParamType)}...`
                              : '...'
                      }`
                    : `${
                          searchResult.length === 0
                              ? 'No'
                              : searchResult.length === patientFuseLimit
                              ? '100+'
                              : searchResult.length
                      } Results Found${
                          useGlobalSearch && currParamType && searchResult.length > 0
                              ? ` (searched by ${displayParamType(currParamType)})`
                              : ''
                      }`}
            </p>
            <div className="overflow-scroll px-8 hide-scrollbar">
                {searchResult.length !== 0 &&
                    searchResult.map((p: Patient) => {
                        const uhid = p.formData?.find((i) => i.key === 'uhid')?.value;

                        return (
                            <div
                                className={`py-10 px-8 flex gap-8 rounded-8 hover:bg-darwin-neutral_new-50 cursor-pointer${
                                    props.selectedPatient && props.selectedPatient.id === p.id
                                        ? ' bg-darwin-neutral_new-50'
                                        : ''
                                }`}
                                onClick={() => setSelectedPatient(p)}
                            >
                                <span
                                    style={{
                                        color: p.personal.onApp
                                            ? undefined
                                            : getColorForString(p.personal.name.f),
                                        backgroundColor: p.personal.onApp
                                            ? undefined
                                            : addAlpha(getColorForString(p.personal.name.f), 0.1),
                                    }}
                                    className={`rounded-full ${
                                        p.personal.onApp
                                            ? 'bg-icon-brand'
                                            : 'bg-darwin-neutral_new-50'
                                    } text-darwin-neutral_new-600 p-4 w-24 h-24 min-w-24 min-h-24 text-12 font-700 flex items-center justify-center`}
                                >
                                    <span>
                                        {p.personal.onApp ? (
                                            <EkaIconGlobalSearch />
                                        ) : (
                                            <Fragment>
                                                {p.personal.name.f &&
                                                getFirstAndLastCharName(p.personal.name.f)
                                                    .firstNameChar
                                                    ? getFirstAndLastCharName(p.personal.name.f)
                                                          .firstNameChar
                                                    : null}
                                                {p.personal.name.f &&
                                                getFirstAndLastCharName(p.personal.name.f)
                                                    .lastNameChar
                                                    ? getFirstAndLastCharName(p.personal.name.f)
                                                          .lastNameChar
                                                    : null}
                                            </Fragment>
                                        )}
                                    </span>
                                </span>
                                <div className="flex flex-col gap-4">
                                    <button className="flex items-start space-x-8 text-13 text-darwin-neutral-900">
                                        <span className="relative flex">
                                            <span className="font-700 break-words flex">
                                                {p.abha?.id ? (
                                                    <span
                                                        className={`w-16 h-16 mr-8 ${getAclViewClassName(
                                                            SREV2.ABHA,
                                                        )}`}
                                                    >
                                                        <AntTooltip content="ABHA address is present">
                                                            {AbhaIconNotLinked}
                                                        </AntTooltip>
                                                    </span>
                                                ) : null}
                                                <AntTooltip
                                                    content={getPtFullNameWithSalutation(p)}
                                                    placement="top"
                                                >
                                                    <span className="truncate-overflow-1 break-all">
                                                        {getPtFullNameWithSalutation(p)}
                                                    </span>
                                                </AntTooltip>
                                            </span>
                                            {p.personal.gender && (
                                                <Fragment>
                                                    <BarIcon className="mx-4 font-700" />
                                                    <span className="uppercase font-700">{`${p.personal.gender[0]}`}</span>
                                                </Fragment>
                                            )}
                                            {p.personal.age && p.personal.age.dob && (
                                                <Fragment>
                                                    <BarIcon className="mx-4 font-700" />
                                                    <span className="uppercase font-700 whitespace-nowrap">
                                                        {`${getAgeString(
                                                            {
                                                                age: p.personal.age.value,
                                                                month: p.personal.age.month,
                                                                dob: p.personal.age.dob,
                                                            },
                                                            ', ',
                                                        )
                                                            .split(', ')
                                                            .slice(1)
                                                            .join(', ')}`}
                                                    </span>
                                                </Fragment>
                                            )}
                                            {uhid && (
                                                <span className="pl-4 whitespace-nowrap">
                                                    (#{uhid})
                                                </span>
                                            )}
                                        </span>
                                    </button>
                                    <div className="flex gap-8 items-center text-12">
                                        <span
                                            className={`flex items-center font-lato text-12 break-words text-darwin-neutral_new-600 max-w-224 ${getAclViewClassName(
                                                SREV2.PATIENT_MOBILE_NUMBER,
                                            )}`}
                                        >
                                            {p.formData?.find((p: any) => p.key === 'uhid')?.value
                                                ? `#${
                                                      p.formData?.find((p: any) => p.key === 'uhid')
                                                          ?.value
                                                  } | `
                                                : ''}
                                            {p.personal.fromNdhmDiscovery &&
                                                p.personal?.['health-ids']?.[0] && (
                                                    <Fragment>
                                                        <svg
                                                            className="flex-shrink-0"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="12"
                                                            height="12"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M7.2027 16.3251C5.82059 16.3251 4.66426 15.8563 4.01172 15.2155C4.66426 14.5747 5.82059 14.106 7.2027 14.106C8.58479 14.106 9.74113 14.5747 10.3937 15.2155C9.74113 15.8563 8.58479 16.3251 7.2027 16.3251Z"
                                                                fill="#19A66A"
                                                                stroke="#19A66A"
                                                                stroke-width="0.97866"
                                                            />
                                                            <path
                                                                d="M16.9563 16.3251C15.6377 16.3251 14.534 15.857 13.9128 15.2155C14.534 14.574 15.6377 14.106 16.9563 14.106C18.2751 14.106 19.3788 14.574 20 15.2155C19.3788 15.857 18.2751 16.3251 16.9563 16.3251Z"
                                                                fill="#19A66A"
                                                                stroke="#19A66A"
                                                                stroke-width="0.97866"
                                                            />
                                                            <path
                                                                d="M7.8238 12.0666C6.79221 11.035 6.28076 9.8187 6.27979 8.85254C7.24596 8.85352 8.46228 9.36495 9.49389 10.3966C10.5255 11.4281 11.0369 12.6445 11.0379 13.6106C10.0717 13.6097 8.8554 13.0982 7.8238 12.0666Z"
                                                                fill="#19A66A"
                                                                stroke="#19A66A"
                                                                stroke-width="0.97866"
                                                            />
                                                            <path
                                                                d="M14.8604 10.3995C15.8921 9.36788 17.1084 8.85645 18.0745 8.85547C18.0735 9.82163 17.5621 11.038 16.5306 12.0696C15.4989 13.1011 14.2826 13.6126 13.3164 13.6136C13.3174 12.6474 13.8288 11.4311 14.8604 10.3995Z"
                                                                fill="#19A66A"
                                                                stroke="#19A66A"
                                                                stroke-width="0.97866"
                                                            />
                                                            <path
                                                                d="M11.2097 8.33807C11.2097 6.89337 11.6788 5.68435 12.3193 5C12.9597 5.68435 13.4288 6.89337 13.4288 8.33807C13.4288 9.78277 12.9597 10.9918 12.3193 11.6761C11.6788 10.9918 11.2097 9.78277 11.2097 8.33807Z"
                                                                fill="#19A66A"
                                                                stroke="#19A66A"
                                                                stroke-width="0.97866"
                                                            />
                                                            <path
                                                                d="M12.1596 18.8816C12.8607 18.8816 13.429 18.3133 13.429 17.6122C13.429 16.9111 12.8607 16.3428 12.1596 16.3428C11.4585 16.3428 10.8901 16.9111 10.8901 17.6122C10.8901 18.3133 11.4585 18.8816 12.1596 18.8816Z"
                                                                fill="#D74B41"
                                                                stroke="#D74B41"
                                                                stroke-width="0.97866"
                                                            />
                                                        </svg>{' '}
                                                        <span>
                                                            {p.personal?.['health-ids']?.[0]}{' '}
                                                        </span>
                                                        <span>&nbsp; | &nbsp;</span>
                                                    </Fragment>
                                                )}
                                            {p['personal']['phone']?.['c']}
                                            {p['personal']['phone']?.['n']}
                                        </span>
                                        {!p.followUpDate && !p.lastVisitedAt ? null : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="4"
                                                height="4"
                                                viewBox="0 0 4 4"
                                                fill="none"
                                                className="flex-shrink-0"
                                            >
                                                <circle cx="2" cy="2" r="2" fill="#BABABA" />
                                            </svg>
                                        )}
                                        <div className="font-lato flex-shrink-0 text-darwin-neutral_new-600">
                                            {p.followUpDate ? (
                                                <div className="flex gap-4 text-12 items-center">
                                                    <svg
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M5.96875 4.375C4.16602 4.375 2.71875 5.84766 2.71875 7.625C2.71875 7.98047 2.43945 8.23438 2.10938 8.23438C1.75391 8.23438 1.5 7.98047 1.5 7.625C1.5 5.16211 3.48047 3.15625 5.96875 3.15625H9.59961V1.73438C9.59961 1.50586 9.72656 1.27734 9.95508 1.17578C10.1836 1.09961 10.4629 1.15039 10.6406 1.32812L12.6719 3.35938C12.9004 3.58789 12.9004 3.96875 12.6719 4.19727L10.6406 6.22852C10.4629 6.40625 10.1836 6.45703 9.95508 6.38086C9.72656 6.2793 9.59961 6.05078 9.59961 5.79688V4.375H5.96875ZM13.8906 7.01562C14.2207 7.01562 14.5 7.29492 14.5 7.625C14.5 10.1133 12.4941 12.0938 10.0312 12.0938H6.375V13.5156C6.375 13.7695 6.22266 13.998 5.99414 14.0996C5.76562 14.1758 5.48633 14.125 5.33398 13.9473L3.27734 11.916C3.04883 11.6875 3.04883 11.3066 3.27734 11.0527L5.33398 9.02148C5.48633 8.86914 5.76562 8.81836 5.99414 8.89453C6.22266 8.99609 6.375 9.22461 6.375 9.45312V10.875H10.0312C11.8086 10.875 13.2812 9.42773 13.2812 7.625C13.2812 7.29492 13.5352 7.01562 13.8906 7.01562Z"
                                                            fill="#767676"
                                                        />
                                                    </svg>
                                                    {p.followUpDate?.toLocaleString('default', {
                                                        weekday: 'short',
                                                    })}
                                                    , {p.followUpDate.getDate()}{' '}
                                                    {p.followUpDate.toLocaleString('default', {
                                                        month: 'short',
                                                    })}
                                                    '
                                                    {p.followUpDate
                                                        .getFullYear()
                                                        .toString()
                                                        .slice(2, 4)}
                                                </div>
                                            ) : p.lastVisitedAt ? (
                                                <div className="flex text-12 gap-4 items-center">
                                                    <svg
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M8 1.125C11.5801 1.125 14.5 4.04492 14.5 7.625C14.5 11.2305 11.5801 14.125 8 14.125C6.6543 14.125 5.43555 13.7441 4.39453 13.0586C4.11523 12.8809 4.03906 12.5 4.2168 12.2207C4.41992 11.9414 4.80078 11.8652 5.08008 12.043C5.91797 12.6016 6.9082 12.9062 8 12.9062C10.8945 12.9062 13.2812 10.5449 13.2812 7.625C13.2812 4.73047 10.8945 2.34375 8 2.34375C6.12109 2.34375 4.4707 3.33398 3.53125 4.78125H4.95312C5.2832 4.78125 5.5625 5.06055 5.5625 5.39062C5.5625 5.74609 5.2832 6 4.95312 6H2.10938C1.75391 6 1.5 5.74609 1.5 5.39062V2.54688C1.5 2.2168 1.75391 1.9375 2.10938 1.9375C2.43945 1.9375 2.71875 2.2168 2.71875 2.54688V3.8418C3.88672 2.2168 5.81641 1.125 8 1.125ZM8 4.375C8.33008 4.375 8.60938 4.6543 8.60938 4.98438V7.39648L10.2344 9.02148C10.4883 9.27539 10.4883 9.65625 10.2344 9.88477C10.0059 10.1387 9.625 10.1387 9.39648 9.88477L7.56836 8.05664C7.44141 7.95508 7.39062 7.80273 7.39062 7.625V4.98438C7.39062 4.6543 7.64453 4.375 8 4.375Z"
                                                            fill="#767676"
                                                        />
                                                    </svg>
                                                    {p.lastVisitedAt.getDate()}{' '}
                                                    {p.lastVisitedAt.toLocaleString('default', {
                                                        month: 'short',
                                                    })}
                                                    '
                                                    {p.lastVisitedAt
                                                        .getFullYear()
                                                        .toString()
                                                        .slice(2, 4)}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            <div
                className={`border-t border-darwin-neutral_new-200 ${getAclViewClassName(
                    SREV2.PATIENT_REGISTRATION,
                )}`}
            >
                <div
                    className="flex gap-8 cursor-pointer rounded-8 items-center px-8 mx-8 py-8 my-2 hover:bg-darwin-accent-bright-blue-100"
                    onClick={onAddPatient}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.2812 7.625C13.2812 7.98047 13.002 8.23438 12.6719 8.23438H8.60938V12.2969C8.60938 12.6523 8.33008 12.9316 8 12.9316C7.64453 12.9316 7.39062 12.6523 7.39062 12.2969V8.23438H3.32812C2.97266 8.23438 2.71875 7.98047 2.71875 7.65039C2.71875 7.29492 2.97266 7.01562 3.32812 7.01562H7.39062V2.95312C7.39062 2.62305 7.64453 2.36914 8 2.36914C8.33008 2.36914 8.60938 2.62305 8.60938 2.95312V7.01562H12.6719C13.002 7.01562 13.2812 7.29492 13.2812 7.625Z"
                            fill="#215FFF"
                        />
                    </svg>
                    <p className="font-700 text-darwin-accent-bright-blue-800">
                        Add New Patient "{props.searchInput}"
                    </p>
                </div>
            </div>
            {onAddPatientViaAbha && (
                <div className={`${getAclViewClassName(SREV2.PATIENT_REGISTRATION)}`}>
                    <div
                        className="flex gap-8 cursor-pointer rounded-8 items-center px-8 mx-8 py-8 my-2 hover:bg-darwin-accent-bright-blue-100"
                        onClick={() => onAddPatientViaAbha('login_with_abha')}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.2812 7.625C13.2812 7.98047 13.002 8.23438 12.6719 8.23438H8.60938V12.2969C8.60938 12.6523 8.33008 12.9316 8 12.9316C7.64453 12.9316 7.39062 12.6523 7.39062 12.2969V8.23438H3.32812C2.97266 8.23438 2.71875 7.98047 2.71875 7.65039C2.71875 7.29492 2.97266 7.01562 3.32812 7.01562H7.39062V2.95312C7.39062 2.62305 7.64453 2.36914 8 2.36914C8.33008 2.36914 8.60938 2.62305 8.60938 2.95312V7.01562H12.6719C13.002 7.01562 13.2812 7.29492 13.2812 7.625Z"
                                fill="#215FFF"
                            />
                        </svg>
                        <div className="font-700 text-darwin-accent-bright-blue-800 flex">
                            Add New Patient "{props.searchInput}" via {AbhaIconLinkedMore} ABHA
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

type GlobalSearchCTAObjWithActions = {
    action: (options?: {
        closeGlobalSearchDialog?: boolean;
        clearGlobalSearchState?: boolean;
        doc?: MyDoc;
    }) => any;
    key: ICTAKEYS;
    icon: JSX.Element;
    dropDownOption?: boolean;
    title: JSX.Element;
    closeGlobalSearch: boolean;
    clearGlobalSearchState: boolean;
    aclViewClassName?: string;
};

export const GlobalSearchPatientSelected: React.FC<{
    selectedPatient: Patient;
    patientPicUrl?: string;
    goToPatientDetails: () => void;
    onPrint: (p: Patient) => Promise<void>;
    allVisits: (Visit & { localInCompletePxId?: string[] })[];
    isPrintRxLoading: boolean;
    closeGlobalSearch: (options?: { clearGlobalSearchState?: boolean }) => void;
    globalSearchCTAObjWithActionsMain: GlobalSearchCTAObjWithActions[];
    globalSearchCTAObjWithActionsDropdown: GlobalSearchCTAObjWithActions[];
    formDataWOUhid: {
        label: string;
        type: 'string' | 'number' | 'select';
        key: string;
        value: string | number;
    }[];
    isAddToQueueDisabled: boolean;
    ctaText: ReactNode;
    currClinic: string;
    setisAddingToQueue: (val: boolean) => void;
    isAddingToQueue: boolean;
    isResumeVisit: boolean;
    patientInQueue: boolean;
}> = (props) => {
    const {
        selectedPatient,
        goToPatientDetails,
        onPrint,
        isPrintRxLoading,
        globalSearchCTAObjWithActionsMain,
        globalSearchCTAObjWithActionsDropdown,
        formDataWOUhid,
        allVisits,
        // closeGlobalSearch,
        patientPicUrl,
        // isAddToQueueDisabled,
        // onStartVisit,
        // ctaText,
        // currClinic,
        // isAddingToQueue,
        // setisAddingToQueue,
        // isResumeVisit,
        // patientInQueue,
    } = props;
    // const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            ekaDispatch({ type: DESTROY_CONTAINER, containerId: GLOBAL_SEARCH_APPT });
        };
    }, []);
    const lastVisit = allVisits.length > 0 ? allVisits[0] : null;

    return (
        <div className="w-50p flex flex-col">
            <div
                id={GLOBAL_SEARCH_APPT}
                className={getAclViewClassName(SREV2.APPOINTMENT_WIDGET)}
            ></div>
            <div className="overflow-scroll hide-scrollbar">
                <PatientProfileCardGlobalSearch
                    selectedPatient={selectedPatient}
                    goToPatientDetails={goToPatientDetails}
                />
                {selectedPatient.personal.onApp && (
                    <div className="px-16 py-4 bg-icon-brand-2">
                        <div className="flex gap-4 justify-center items-center">
                            <EkaIconGlobalSearchRightPanel />
                            <p className="text-11">
                                <span className="text-icon-brand text-11 font-700">
                                    Connected on Eka.Care app:
                                </span>{' '}
                                Instant records, easy followups.
                            </p>
                        </div>
                    </div>
                )}
                <div className="py-10 border-b flex justify-between items-center border-darwin-neutral_new-200 px-16 bg-white w-full">
                    {globalSearchCTAObjWithActionsMain.map((cta, idx) => {
                        const Wrapper = cta.key === 'MCERT' ? DoctorSelectorPopup : Fragment;
                        return (
                            <Wrapper
                                onSelect={(doc?: MyDoc) =>
                                    cta.action({
                                        closeGlobalSearchDialog: cta.closeGlobalSearch,
                                        clearGlobalSearchState: cta.clearGlobalSearchState,
                                        doc,
                                    })
                                }
                                clinicId={getSelectedClinicId()}
                            >
                                <AntTooltip
                                    content={cta.title}
                                    placement={idx === 0 ? 'bottomLeft' : 'bottom'}
                                >
                                    <div
                                        className={`bg-darwin-neutral_new-50 hover:bg-darwin-neutral-75 cursor-pointer p-6 rounded-8 ${
                                            cta.aclViewClassName || ''
                                        }`}
                                        onClick={() =>
                                            cta.action({
                                                closeGlobalSearchDialog: cta.closeGlobalSearch,
                                                clearGlobalSearchState: cta.clearGlobalSearchState,
                                            })
                                        }
                                    >
                                        <div
                                            className={`fill-darwin-neutral_new-1000 ${
                                                cta.key === 'PAST_VISITS' ? 'p-0' : 'p-4'
                                            }`}
                                        >
                                            {cta.icon}
                                        </div>
                                    </div>
                                </AntTooltip>
                            </Wrapper>
                        );
                    })}
                    <Dropdown
                        overlay={
                            <Menu className="rounded-8 cursor-pointer p-0">
                                <Menu.Item
                                    // onClick={() => closeGlobalSearch()}
                                    className={`p-0 cursor-pointer hover:bg-darwin-neutral_new-50 rounded-t-8 ${getAclViewClassName(
                                        SREV2.UPLOAD_MEDICAL_RECORDS,
                                    )}`}
                                >
                                    <AddRecordsBtV2
                                        ptId={selectedPatient.localId}
                                        text="Add records"
                                        icon={
                                            <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M7.60938 9.76562C7.60938 10.1211 7.33008 10.375 7 10.375C6.64453 10.375 6.39062 10.1211 6.39062 9.76562V2.70703L3.97852 5.11914C3.72461 5.37305 3.34375 5.37305 3.11523 5.11914C2.86133 4.89062 2.86133 4.50977 3.11523 4.25586L6.56836 0.802734C6.79688 0.574219 7.17773 0.574219 7.40625 0.802734L10.8848 4.25586C11.1133 4.50977 11.1133 4.89062 10.8848 5.11914C10.6309 5.37305 10.25 5.37305 10.0215 5.11914L7.60938 2.70703V9.76562ZM8.42188 9.5625V8.34375H11.875C12.7637 8.34375 13.5 9.08008 13.5 9.96875V12C13.5 12.9141 12.7637 13.625 11.875 13.625H2.125C1.21094 13.625 0.5 12.9141 0.5 12V9.96875C0.5 9.08008 1.21094 8.34375 2.125 8.34375H5.57812V9.5625H2.125C1.89648 9.5625 1.71875 9.76562 1.71875 9.96875V12C1.71875 12.2285 1.89648 12.4062 2.125 12.4062H11.875C12.0781 12.4062 12.2812 12.2285 12.2812 12V9.96875C12.2812 9.76562 12.0781 9.5625 11.875 9.5625H8.42188ZM10.25 10.9844C10.25 10.6543 10.5039 10.375 10.8594 10.375C11.1895 10.375 11.4688 10.6543 11.4688 10.9844C11.4688 11.3398 11.1895 11.5938 10.8594 11.5938C10.5039 11.5938 10.25 11.3398 10.25 10.9844Z"
                                                    fill="#1A1A1A"
                                                />
                                            </svg>
                                        }
                                        key={selectedPatient.localId}
                                        cssClass="w-full cursor-pointer flex py-10 px-16 gap-8 items-center"
                                        cssClassInner="flex h-full w-full items-center gap-9"
                                        from="global-search"
                                    />
                                </Menu.Item>
                                {globalSearchCTAObjWithActionsDropdown.map((opt, i) => (
                                    <Menu.Item
                                        onClick={() =>
                                            opt.action({
                                                closeGlobalSearchDialog: opt.closeGlobalSearch,
                                                clearGlobalSearchState: opt.clearGlobalSearchState,
                                            })
                                        }
                                        className={`p-0 hover:bg-darwin-neutral_new-50
                                            ${
                                                i + 1 ===
                                                    globalSearchCTAObjWithActionsDropdown.length &&
                                                'rounded-b-8'
                                            } ${opt.aclViewClassName || ''}`}
                                    >
                                        <div className="flex py-10 px-16 gap-8 items-center">
                                            <span>{opt.icon}</span>
                                            {opt.title}
                                        </div>
                                    </Menu.Item>
                                ))}
                            </Menu>
                        }
                        placement="bottomRight"
                        trigger={['click']}
                    >
                        <div className="bg-darwin-neutral_new-50 hover:bg-darwin-neutral-75 cursor-pointer p-6 rounded-8">
                            <div className="p-4 fill-darwin-neutral_new-1000">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 4 14"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M2 10.5C2.8125 10.5 3.5 11.1875 3.5 12C3.5 12.8438 2.8125 13.5 2 13.5C1.15625 13.5 0.5 12.8438 0.5 12C0.5 11.1875 1.15625 10.5 2 10.5ZM2 5.5C2.8125 5.5 3.5 6.1875 3.5 7C3.5 7.84375 2.8125 8.5 2 8.5C1.15625 8.5 0.5 7.84375 0.5 7C0.5 6.1875 1.15625 5.5 2 5.5ZM2 3.5C1.15625 3.5 0.5 2.84375 0.5 2C0.5 1.1875 1.15625 0.5 2 0.5C2.8125 0.5 3.5 1.1875 3.5 2C3.5 2.84375 2.8125 3.5 2 3.5Z" />
                                </svg>
                            </div>
                        </div>
                    </Dropdown>
                </div>
                {lastVisit && (
                    <div className="border-b flex border-darwin-neutral_new-200 w-full px-16 py-12 gap-8">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="flex-shrink-0 mt-8"
                        >
                            <path
                                d="M3.4043 3.0293C4.57227 1.86133 6.19727 1.125 8 1.125C11.5801 1.125 14.5 4.04492 14.5 7.625C14.5 11.2305 11.5801 14.125 8 14.125C6.60352 14.125 5.33398 13.6934 4.26758 12.9824C3.91211 12.7031 3.81055 12.1953 4.06445 11.8398C4.31836 11.459 4.82617 11.3828 5.20703 11.6367C5.99414 12.1953 6.95898 12.5 8 12.5C10.6914 12.5 12.875 10.3164 12.875 7.625C12.875 4.93359 10.6914 2.75 8 2.75C6.6543 2.75 5.43555 3.30859 4.54688 4.19727L5.33398 4.95898C5.71484 5.36523 5.43555 6 4.90234 6H2.10938C1.75391 6 1.5 5.74609 1.5 5.39062V2.59766C1.5 2.06445 2.13477 1.78516 2.54102 2.16602L3.4043 3.0293ZM8 4.375H7.97461C8.33008 4.375 8.58398 4.6543 8.58398 4.98438V7.39648L10.2344 9.04688C10.4883 9.27539 10.4883 9.65625 10.2344 9.88477C10.0059 10.1387 9.625 10.1387 9.39648 9.88477L7.56836 8.05664C7.44141 7.95508 7.39062 7.80273 7.39062 7.625V4.98438C7.39062 4.6543 7.64453 4.375 8 4.375Z"
                                fill="#767676"
                            />
                        </svg>
                        <div className="bg-darwin-neutral_new-50 p-8 flex justify-between items-center rounded-8 gap-4 w-full">
                            <div className="flex-col flex gap-4">
                                <p className="text-10 font-700">LAST VISIT</p>
                                <div className="font-700 flex text-13">
                                    {new Date(lastVisit.createdAt).toLocaleString('default', {
                                        weekday: 'short',
                                    })}
                                    , {new Date(lastVisit.createdAt).getDate()}{' '}
                                    {new Date(lastVisit.createdAt).toLocaleString('default', {
                                        month: 'short',
                                    })}
                                    '
                                    {new Date(lastVisit.createdAt)
                                        .getFullYear()
                                        .toString()
                                        .slice(2, 4)}
                                    <BarIcon className="mx-4" />
                                    <p className="text-13 font-400">
                                        {lastVisit.doc_name || 'Unknown'}
                                    </p>
                                </div>
                            </div>
                            {isPrintRxLoading ? (
                                <div className="bg-white flex p-8 rounded-8 items-center">
                                    <svg
                                        viewBox="0 0 512 512"
                                        className="fill-darwin-accent-bright-blue-800 animate-spin"
                                        width="14"
                                        height="14"
                                    >
                                        <path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
                                    </svg>
                                </div>
                            ) : (
                                <div
                                    className={`bg-white flex p-8 rounded-8 items-center ${
                                        !lastVisit.prescriptionUrl
                                            ? 'cursor-not-allowed'
                                            : 'cursor-pointer'
                                    }`}
                                    onClick={() =>
                                        lastVisit.prescriptionUrl && onPrint(selectedPatient)
                                    }
                                    title={
                                        !lastVisit.prescriptionUrl
                                            ? 'No prescription for the last visit'
                                            : ''
                                    }
                                >
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3.31836 1.34375L3.34375 4.1875H2.125V3.45117V1.34375C2.125 0.683594 2.6582 0.125 3.31836 0.125H9.79297C10.0977 0.125 10.4277 0.277344 10.6562 0.505859L11.4941 1.34375C11.7227 1.57227 11.875 1.90234 11.875 2.20703V4.1875H10.6562V2.20703L9.76758 1.34375H3.31836ZM11.6719 5C12.6621 5 13.5 5.83789 13.5 6.82812V9.67188C13.5 10.0273 13.2207 10.2812 12.8906 10.2812H11.4688V12.3125C11.4688 12.7695 11.0879 13.125 10.6562 13.125H3.34375C2.88672 13.125 2.53125 12.7695 2.53125 12.3125V10.2812H1.10938C0.753906 10.2812 0.5 10.0273 0.5 9.67188V6.82812C0.5 5.83789 1.3125 5 2.32812 5H11.6719ZM10.25 11.9062V9.46875H3.75V11.9062H10.25ZM12.2812 9.0625V6.82812C12.2812 6.49805 12.002 6.21875 11.6719 6.21875H2.32812C1.97266 6.21875 1.71875 6.49805 1.71875 6.82812V9.0625H2.53125C2.53125 8.63086 2.88672 8.25 3.34375 8.25H10.6562C11.0879 8.25 11.4688 8.63086 11.4688 9.0625H12.2812Z"
                                            fill={
                                                !lastVisit.prescriptionUrl ? '#767676' : '#215FFF'
                                            }
                                        />
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {formDataWOUhid && formDataWOUhid.length !== 0 && (
                    <div className="border-b flex flex-col border-darwin-neutral_new-200 w-full">
                        <p className="font-700 text-14 px-16 pt-16 pb-8">Other details</p>
                        <div className="flex flex-col">
                            {formDataWOUhid.map((data) => (
                                <div className="flex flex-col gap-4 px-16 py-10">
                                    <p
                                        className="text-darwin-neutral_new-600 font-11 font-700 uppercase"
                                        style={{ fontSize: 11 }}
                                    >
                                        {data.label}
                                    </p>
                                    {data.key === 'tag' ? (
                                        <span
                                            className="py-4 px-8 bg-darwin-neutral_new-50 rounded-4"
                                            style={{ width: 'fit-content' }}
                                        >
                                            <p className="text-13 font-400">{data.value}</p>
                                        </span>
                                    ) : (
                                        <p className="text-13 font-400">{data.value}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {/* <div className="flex w-full mt-auto">
                <div className="flex w-full bg-white border-t border-darwin-neutral_new-200 px-8 py-12 gap-8 justify-center">
                    <div
                        className={`flex py-10 w-full px-12 text-13 justify-center items-center gap-8 rounded-8 border ${
                            isAddToQueueDisabled
                                ? 'border-darwin-neutral-200 text-darwin-neutral_new-600'
                                : 'cursor-pointer font-700 border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800'
                        }`}
                        onClick={(e) => {
                            if (isAddToQueueDisabled) {
                                return;
                            }

                            onAddToQueue(
                                e,
                                selectedPatient,
                                currClinic,
                                closeGlobalSearch,
                                (val: boolean) => {
                                    setisAddingToQueue(val);
                                },
                            );
                        }}
                    >
                        <span>Add to queue</span>
                        {isAddingToQueue ? (
                            <div
                                className="pulse flex items-center mr-6 scale-110"
                                style={{ transform: 'scale(1.2)', height: '25px' }}
                            >
                                <svg width="16px" height="12px">
                                    <polyline
                                        id="back"
                                        points="1 6 4 6 6 11 10 1 12 6 15 6"
                                    ></polyline>
                                    <polyline
                                        id="front"
                                        points="1 6 4 6 6 11 10 1 12 6 15 6"
                                    ></polyline>
                                </svg>
                            </div>
                        ) : (
                            <svg
                                width="18"
                                height="14"
                                viewBox="0 0 18 14"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`${
                                    isAddToQueueDisabled
                                        ? 'fill-darwin-neutral_new-600'
                                        : 'fill-darwin-accent-bright-blue-800'
                                }`}
                            >
                                <path d="M6.15625 3.0625C5.69922 3.0625 5.31836 2.83398 5.08984 2.45312C4.86133 2.09766 4.86133 1.61523 5.08984 1.23438C5.31836 0.878906 5.69922 0.625 6.15625 0.625C6.58789 0.625 6.96875 0.878906 7.19727 1.23438C7.42578 1.61523 7.42578 2.09766 7.19727 2.45312C6.96875 2.83398 6.58789 3.0625 6.15625 3.0625ZM4.45508 7.4043C4.42969 7.48047 4.45508 7.58203 4.53125 7.63281L4.9375 7.96289L5.77539 5.32227C5.77539 5.32227 5.77539 5.32227 5.77539 5.29688C5.59766 5.2207 5.41992 5.14453 5.2168 5.11914L4.45508 7.4043ZM5.95312 8.80078L7.22266 9.81641C7.40039 9.96875 7.52734 10.1719 7.57812 10.375L8.16211 12.8887C8.23828 13.2188 8.03516 13.5488 7.70508 13.625C7.375 13.7012 7.04492 13.498 6.96875 13.168L6.41016 10.7305L3.76953 8.57227C3.28711 8.19141 3.10938 7.58203 3.3125 7.02344L3.89648 5.29688C3.26172 5.52539 2.75391 6.00781 2.47461 6.64258L2.2207 7.17578C2.09375 7.48047 1.73828 7.63281 1.43359 7.48047C1.12891 7.35352 0.976562 6.99805 1.12891 6.69336L1.35742 6.13477C1.78906 5.16992 2.62695 4.4082 3.64258 4.07812C4.02344 3.95117 4.42969 3.875 4.83594 3.875H4.96289C6.2832 3.875 7.47656 4.76367 7.83203 6.05859L8.11133 7.02344L8.79688 7.73438C9.05078 7.96289 9.05078 8.34375 8.79688 8.57227C8.56836 8.82617 8.1875 8.82617 7.95898 8.57227L7.22266 7.83594C7.0957 7.73438 6.99414 7.58203 6.94336 7.4043L6.68945 6.46484L5.95312 8.80078ZM3.38867 9.33398L4.37891 10.1211L3.89648 11.3398C3.8457 11.4668 3.76953 11.5938 3.66797 11.6953L1.89062 13.4473C1.66211 13.7012 1.28125 13.7012 1.05273 13.4473C0.798828 13.2188 0.798828 12.8379 1.05273 12.584L2.7793 10.8574L3.38867 9.33398ZM11.4375 1.23438V2.45312C11.4375 2.80859 11.1582 3.0625 10.8281 3.0625C10.4727 3.0625 10.2188 2.80859 10.2188 2.45312V1.23438C10.2188 0.904297 10.4727 0.625 10.8281 0.625C11.1582 0.625 11.4375 0.904297 11.4375 1.23438ZM14.916 4.66211L16.9473 6.69336C17.1758 6.94727 17.1758 7.32812 16.9473 7.55664L14.916 9.58789C14.6621 9.8418 14.2812 9.8418 14.0527 9.58789C13.7988 9.35938 13.7988 8.97852 14.0527 8.72461L15.043 7.73438H10.8281C10.4727 7.73438 10.2188 7.48047 10.2188 7.125C10.2188 6.79492 10.4727 6.51562 10.8281 6.51562H15.043L14.0527 5.52539C13.7988 5.29688 13.7988 4.91602 14.0527 4.66211C14.2812 4.43359 14.6621 4.43359 14.916 4.66211ZM10.8281 3.875C11.1582 3.875 11.4375 4.1543 11.4375 4.48438V4.89062C11.4375 5.24609 11.1582 5.5 10.8281 5.5C10.4727 5.5 10.2188 5.24609 10.2188 4.89062V4.48438C10.2188 4.1543 10.4727 3.875 10.8281 3.875ZM11.4375 9.35938V9.76562C11.4375 10.1211 11.1582 10.375 10.8281 10.375C10.4727 10.375 10.2188 10.1211 10.2188 9.76562V9.35938C10.2188 9.0293 10.4727 8.75 10.8281 8.75C11.1582 8.75 11.4375 9.0293 11.4375 9.35938ZM10.8281 11.1875C11.1582 11.1875 11.4375 11.4668 11.4375 11.7969V13.0156C11.4375 13.3711 11.1582 13.625 10.8281 13.625C10.4727 13.625 10.2188 13.3711 10.2188 13.0156V11.7969C10.2188 11.4668 10.4727 11.1875 10.8281 11.1875Z" />
                            </svg>
                        )}
                    </div>
                    <StartVisitBtnComp
                        ctaText={ctaText}
                        isResumeVisit={isResumeVisit}
                        onStartVisit={onStartVisit}
                        patientInQueue={patientInQueue}
                        dispatch={dispatch}
                    />
                </div>
            </div> */}
        </div>
    );
};

const GlobalSearchRightPanel: React.FC<{
    selectedPatient: Patient | undefined;
    patientPicUrl: string | undefined;
    goToPatientDetails: () => void;
    onPrint: (p: Patient) => Promise<void>;
    allVisits: (Visit & { localInCompletePxId?: string[] })[]; // all visits of the patient
    isPrintRxLoading: boolean;
    globalSearchCTAObjWithActionsMain: GlobalSearchCTAObjWithActions[];
    globalSearchCTAObjWithActionsDropdown: GlobalSearchCTAObjWithActions[];
    closeGlobalSearch: (options?: { clearGlobalSearchState?: boolean }) => void;
    todayAppointments: AP[];
}> = (props) => {
    const {
        selectedPatient,
        goToPatientDetails,
        onPrint,
        allVisits,
        isPrintRxLoading,
        globalSearchCTAObjWithActionsMain,
        globalSearchCTAObjWithActionsDropdown,
        closeGlobalSearch,
        todayAppointments,
        patientPicUrl,
    } = props;

    const [isAddingToQueue, setisAddingToQueue] = useState(false);
    const dispatch = useDispatch();
    const currClinic = getSelectedClinicId() ?? '';

    useEffect(() => {
        if (selectedPatient?.localId) {
            setTimeout(() => {
                renderGlobalSearchApptComponent({
                    containerId: GLOBAL_SEARCH_APPT,
                    ptOid: selectedPatient?.localId,
                    clinicId: currClinic,
                });
            }, 500);
        }
    }, [selectedPatient?.localId]);

    const formDataWOUhid = selectedPatient?.formData?.filter((f: any) => f.key !== 'uhid') ?? [];

    const currAppt =
        selectedPatient && todayAppointments.find((a) => a.patient_oid === selectedPatient.id);

    const apptIndex =
        selectedPatient && todayAppointments
            ? todayAppointments.findIndex((a) => a.patient_oid === selectedPatient.id)
            : -1;

    const apptAction =
        todayAppointments && apptIndex > -1 && todayAppointments[apptIndex]
            ? getAppointmentAction(todayAppointments[apptIndex])
            : undefined;

    const patientInQueue = apptAction ? apptAction === START_VISIT : false;

    const isResumeVisit = apptAction
        ? apptAction === RE_START ||
          apptAction === PARKED ||
          apptAction === ONGOING ||
          apptAction === PARKED_ON_OTHER_DEVICE
            ? true
            : false
        : false;

    const ctaText = apptAction
        ? apptAction === RE_START
            ? 'Resume Visit'
            : getAppointmentActionTextForAction(apptAction, true)
        : 'Start Visit';

    const isAddToQueueDisabled = patientInQueue || isResumeVisit;

    function onStartVisit(context: StartVisitBtn, docid: string) {
        if (currAppt && apptIndex > -1) {
            onAppointmentAction(context, currAppt, currClinic);
        } else {
            onCreateVisit({
                patient: selectedPatient,
                docid,
                dispatch,
                history: his,
                cId: currClinic,
            });
        }

        closeGlobalSearch();
    }

    return (
        <Fragment>
            {selectedPatient ? (
                <GlobalSearchPatientSelected
                    selectedPatient={selectedPatient}
                    patientPicUrl={patientPicUrl}
                    goToPatientDetails={goToPatientDetails}
                    onPrint={onPrint}
                    allVisits={allVisits}
                    isPrintRxLoading={isPrintRxLoading}
                    globalSearchCTAObjWithActionsMain={globalSearchCTAObjWithActionsMain}
                    globalSearchCTAObjWithActionsDropdown={globalSearchCTAObjWithActionsDropdown}
                    closeGlobalSearch={closeGlobalSearch}
                    ctaText={ctaText}
                    formDataWOUhid={formDataWOUhid}
                    isAddToQueueDisabled={isAddToQueueDisabled}
                    currClinic={currClinic}
                    isAddingToQueue={isAddingToQueue}
                    setisAddingToQueue={setisAddingToQueue}
                    isResumeVisit={isResumeVisit}
                    patientInQueue={patientInQueue}
                />
            ) : (
                <div className="w-50p gap-16 flex flex-col justify-center items-center">
                    <GlobalSearchPtNotSelected />
                    <p className="text-neutral-black">Select a patient for patient overview</p>
                </div>
            )}
        </Fragment>
    );
};

export const PatientProfileCardGlobalSearch: React.FC<{
    selectedPatient: Patient;
    goToPatientDetails: () => void;
    border?: boolean;
}> = ({ border = true, ...props }) => {
    const { selectedPatient } = props;

    const patientPicUrl = getPatientPicUrl(selectedPatient.localId);

    return (
        <div
            className={`pt-profile-details bg-white hover:bg-darwin-neutral_new-50 cursor-pointer ${
                border ? 'border-b border-darwin-neutral_new-200' : ''
            }  gap-8 flex w-full p-16`}
            onClick={props.goToPatientDetails}
        >
            <img
                key={selectedPatient.localId}
                src={patientPicUrl}
                onError={(e) => {
                    e.currentTarget.src = 'https://a.eka.care/user-avatar/dummyimage';
                }}
                // alt={patientPicUrl && 'Patient Profile Pic'}
                className="rounded-full h-36 w-36 flex-shrink-0"
            />

            <div className="flex flex-col w-full gap-2">
                <p className="font-700 text-16 flex">
                    <span className="max-w-184 flex">
                        {selectedPatient.abha?.id ? (
                            <span className={`w-16 h-16 mr-8 ${getAclViewClassName(SREV2.ABHA)}`}>
                                <AntTooltip content="ABHA address is present">
                                    {AbhaIconNotLinked}
                                </AntTooltip>
                            </span>
                        ) : null}
                        {getPtFullNameWithSalutation(selectedPatient)}
                    </span>
                    {selectedPatient.personal.gender && (
                        <Fragment>
                            <BarIcon className="mx-4" />
                            <span className="uppercase">{`${selectedPatient.personal.gender[0]}`}</span>
                        </Fragment>
                    )}
                    {selectedPatient.personal.age && selectedPatient.personal.age.dob && (
                        <Fragment>
                            <BarIcon className="mx-4" />
                            <span className="uppercase whitespace-nowrap">
                                {`${getAgeString(
                                    {
                                        age: selectedPatient.personal.age.value,
                                        month: selectedPatient.personal.age.month,
                                        dob: selectedPatient.personal.age.dob,
                                    },
                                    ', ',
                                )
                                    .split(', ')
                                    .slice(1)
                                    .join(', ')}`}
                                {/* {JSON.stringify(selectedPatient.personal.age)} */}
                            </span>
                        </Fragment>
                    )}
                </p>
                <div className="flex font-400 text-13 text-darwin-neutral_new-800">
                    {selectedPatient.formData?.find((f: any) => f.key === 'uhid')?.value && (
                        <Fragment>
                            <span>
                                <span>#</span>
                                {
                                    selectedPatient.formData?.find((f: any) => f.key === 'uhid')
                                        ?.value
                                }
                            </span>
                            {selectedPatient.personal.phone?.n && (
                                <BarIcon className="text-darwin-neutral_new-800 mx-4" />
                            )}
                        </Fragment>
                    )}

                    {selectedPatient.personal.phone?.n && (
                        <span>
                            {selectedPatient.personal.phone?.c} {selectedPatient.personal.phone?.n}
                        </span>
                    )}
                </div>
                {selectedPatient.abha?.id && (
                    <div
                        className={`flex font-400 text-13 text-darwin-neutral_new-800 ${getAclViewClassName(
                            SREV2.ABHA,
                        )}`}
                    >
                        <span>{selectedPatient.abha.id}</span>
                    </div>
                )}
            </div>

            <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0"
            >
                <rect width="28" height="28" rx="4" fill="#F4F4F4" />
                <path
                    d="M12.8066 8.34375L17.4531 13.1934C17.5547 13.3203 17.6309 13.4727 17.6309 13.625C17.6309 13.7773 17.5547 13.9297 17.4531 14.0312L12.8066 18.8809C12.5781 19.1348 12.1719 19.1348 11.9434 18.9062C11.6895 18.6777 11.6895 18.2969 11.918 18.043L16.1836 13.5996L11.918 9.18164C11.6895 8.95312 11.6895 8.54688 11.9434 8.31836C12.1719 8.08984 12.5781 8.08984 12.8066 8.34375Z"
                    fill="#1A1A1A"
                />
            </svg>
        </div>
    );
};

export default GlobalSearchModal;

const BarIcon: React.FC<{ className?: string }> = (props) => (
    <span className={props.className ?? ''}>|</span>
);
